const headers = {
    'X-RapidAPI-Key': '16841ac6b5msh721cc5fa7cc9021p147444jsn7d45a1721e39',
    'X-RapidAPI-Host': 'trading-view.p.rapidapi.com'
};
const params = [
    {
        id: '1',
        name: 'BBCA',
        columns: 'name,average_volume,close,open',
        symbol: 'IDX:BBCA',
        screenerName: 'indonesia',
        lang: 'en'
    }, {
        id: '2',
        name: 'BBRI',
        columns: 'name,average_volume,close,open',
        symbol: 'IDX:BBRI',
        screenerName: 'indonesia',
        lang: 'en'
    }];

export { params };
export default headers;